import React, { Fragment, useEffect, useState } from "react";
import { get, post } from "../Services/http";
import { translate } from "../Services/translation";
function GdprConsent() {
    const [consentText, setConsentText] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [checked, setChecked] = useState(false);
    const consentUrl = "/api/consent";
    const consentWaitKey = "consentWait";
    useEffect(() => {
      
        const getConsentText = () => get(consentUrl)
            .then((res) => res.json())
            .then((res) => {
                setConsentText(res.text);
            });

        let state = JSON.parse(localStorage.getItem("consentState"));
        state =
            state == null
                ? {
                      IsAvailable: false,
                      GdprConsentAccepted: false,
                  }
                : state;
        let visible = state.IsAvailable && !state.GdprConsentAccepted;
        visible = getRejectStorage(visible).visible;
        setIsVisible(visible);
        visible && getConsentText();
        window.subscribeToEvent("openConsentModal", function (data) {

            if (!data && !data.detail)
                return;
            setIsVisible(data.detail.show);
            if (data.detail.show) {
                getConsentText();
            }
        });

        return () => {
            window.unsubscribeToEvent("openConsentModal");
        }
    }, []);

    function getRejectStorage(visibleState) {
        try {
            let item = localStorage.getItem(consentWaitKey);
            if (!visibleState || item == null) return { visible: visibleState };

            let storage = JSON.parse(item);
            let storedDate = new Date(storage.date);
            let currentDate = new Date();

            return { visible: storedDate <= currentDate };
        } catch (error) {
            return { visible: visibleState };
        }
    }

    function handleRejectStorage(accept) {
        if (!accept) {
            let waitingTime = new Date();
            waitingTime.setDate(waitingTime.getDate() + 1);
            let data = JSON.stringify({ date: waitingTime.toISOString() });
            localStorage.setItem(consentWaitKey, data);
        }
    }

    const handleChange = () => {
        setChecked(!checked);
    };

    const HandleSubmit = (accept) => {
        handleRejectStorage(accept);
        setIsloading(true);
        post(consentUrl, {
            accept: accept,
        }).then((res) => res.json()).then(data => {

           window.publishEvent("onconsentmodalActions", { accepted: accept });
            
        })
        .catch(() => {
                alert(translate("consent.error"));
            })
            .finally(() => {
                setIsloading(false);
                setIsVisible(false);
            });
    };
    return (
        isVisible &&
        (consentText != null || consentText !== "") && (
            <Fragment>
                <div
                    className="b-modal fade show"
                    style={{ display: "block", "z-index": "10010;" }}
                >
                    <div
                        className="b-modal-dialog b-modal-dialog-centered  b-modal-xl b-modal-fullscreen-sm-down"
                        role="document"
                    >
                        <div className="b-modal-content">
                            <div className="b-modal-header">
                                <h5 className="b-modal-title">
                                    {translate("consent.title")}
                                </h5>
                            </div>
                            <div className="b-modal-body">
                                <div className="b-content-scrollable">
                                    <p>{consentText}</p>
                                </div>
                                <div class="b-row">
                                    <div class="b-col-sm-12">
                                        <div className="gdprcheck-container">
                                            <input
                                                id="gdprcheck"
                                                type="checkbox"
                                                className="gdprcheck"
                                                checked={checked}
                                                disabled={isloading}
                                                onChange={handleChange}
                                            />
                                            <label
                                                className="gdprcheck"
                                                for="gdprcheck"
                                            >
                                                {translate("mypage.GDPR")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="b-modal-footer">
                                {isloading ? (
                                    <div class="loader-wrap">
                                        <div class="loader"></div>
                                    </div>
                                ) : (
                                    <Fragment>
                                        <button
                                            type="button"
                                            onClick={() => HandleSubmit(true)}
                                            disabled={!checked}
                                            className="btn-gdpr btn btn--green"
                                        >
                                            {translate("consent.btn.accept")}
                                        </button>
                                        <button
                                            type="button"
                                            disabled={checked}
                                            onClick={() => HandleSubmit(false)}
                                            className="btn-gdpr btn btn--red"
                                        >
                                            {translate("consent.btn.reject")}
                                        </button>
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="b-modal-backdrop b-fade show"></div>
            </Fragment>
        )
    );
}

export default GdprConsent;
